/**
 * Pure gate rules for Carteira access overlays (choose / waiting / suspended / loading).
 * Used by PrivateApp so login with 0–1 selectable accounts never flashes "Escolher conta".
 *
 * Named *Rules* to avoid Windows case-clash with CarteiraAccessGate.tsx.
 */

/**
 * While pick is pending and /me is not ready, block the dashboard with a loading gate.
 * @param {{
 *   pickPending: boolean,
 *   profileReady: boolean,
 *   canAccessCarteira: boolean | undefined,
 *   isBaasPath: boolean,
 * }} args
 */
export const shouldShowAccountPickLoadingGate = ({
  pickPending,
  profileReady,
  canAccessCarteira,
  isBaasPath,
}) =>
  Boolean(pickPending)
  && !profileReady
  && canAccessCarteira !== false
  && !isBaasPath;

/**
 * @param {{
 *   pickPending: boolean,
 *   selectableCount: number,
 *   selectedAccountInactive: boolean,
 *   showWaitingGate: boolean,
 * }} args
 */
export const shouldShowChooseAccountGate = ({
  pickPending,
  selectableCount,
  selectedAccountInactive,
  showWaitingGate,
}) =>
  Boolean(pickPending)
  && Number(selectableCount) > 1
  && !selectedAccountInactive
  && !showWaitingGate;

/**
 * @param {{
 *   canAccessCarteira: boolean | undefined,
 *   isBaasPath: boolean,
 *   profileReady: boolean,
 *   selectedAccountInactive: boolean,
 *   showWaitingGate: boolean,
 *   showChooseGate: boolean,
 *   showLoadingGate?: boolean,
 * }} args
 */
export const shouldShowCarteiraAccessGate = ({
  canAccessCarteira,
  isBaasPath,
  profileReady,
  selectedAccountInactive,
  showWaitingGate,
  showChooseGate,
  showLoadingGate = false,
}) =>
  canAccessCarteira !== false
  && !isBaasPath
  && (
    Boolean(showLoadingGate)
    || (
      Boolean(profileReady)
      && Boolean(selectedAccountInactive || showWaitingGate || showChooseGate)
    )
  );
